import Auth from './actions/auth'
import Settings from './actions/settings'
import Notifications from './notifications'
const state = {
    user: null,
};
const mutations = {
    SET_USER(state, user){
        state.user = user;
        if (user){
            let token = window.localStorage.getItem('tK');
            window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        }
    },
    UPDATE_USER(state, data){
        Object.assign(state.user, data);
    },
    SET_USER_BALANCE(state, balance){
        Object.assign(state.user, {balance});
    },
    ...Notifications.mutations
};
const actions = {
    ...Auth,
    ...Settings,
    ...Notifications.actions
};

export default {state, mutations, actions};